/**
 * Success Messages
 *
 * Constants for success messages used in mutation hooks.
 * Centralises user-facing feedback strings so they are easy to
 * find, translate, and keep consistent across the application.
 */

// -- Errors -----------------------------------------------------------------
export const ERRORS = {
  FIELD_REQUIRED: (field: string, action: string) => `Field ${field} is required for ${action}.`
} as const;

// -- Scope ------------------------------------------------------------------
export const SCOPE_SUBMITTED = 'Scope submitted successfully' as const;
export const SCOPE_ACCEPTED = 'Scope accepted successfully' as const;
export const SCOPE_REJECTED = 'Scope rejected successfully' as const;

// -- Milestones -------------------------------------------------------------
export const MILESTONE_SUBMITTED = 'Milestone submitted successfully' as const;
export const MILESTONE_ACCEPTED = 'Milestone accepted successfully' as const;
export const MILESTONE_REJECTED = 'Milestone rejected successfully' as const;
export const MILESTONE_UPDATED = 'Milestone updated successfully' as const;
export const MILESTONE_DELETED = 'Milestone deleted successfully' as const;

// -- Votes / Ratings --------------------------------------------------------
export const VOTES_SUBMITTED = 'Votes submitted successfully' as const;
export const COORDINATOR_RATINGS_SUBMITTED = 'Coordinator ratings submitted successfully' as const;
export const DEVELOPER_RATING_SUBMITTED = 'Developer rating submitted successfully' as const;

// -- Payments ---------------------------------------------------------------
export const PAYMENT_RELEASED = 'Payment released successfully' as const;

// -- Projects ---------------------------------------------------------------
export const PROPOSAL_REJECTED = 'Proposal rejected successfully' as const;
export const COORDINATOR_ASSIGNED = 'Coordinator assigned successfully' as const;
export const TEAM_ASSIGNED = 'Team assigned successfully' as const;
export const CALENDAR_CONTRACT_SET = 'Calendar contract set successfully' as const;

// -- Profile ----------------------------------------------------------------
export const PROFILE_IMAGE_UPLOADED = 'Profile image uploaded successfully' as const;

// -- Disputes (DevStory 4.5) ------------------------------------------------
export const DISPUTE_OPENED = 'Dispute opened successfully' as const;
export const DISPUTE_ARGUMENT_ADDED = 'Argument added to dispute successfully' as const;
export const DISPUTE_MESSAGE_SENT = 'Dispute message sent successfully' as const;
export const DISPUTE_RESOLVED = 'Dispute resolved successfully' as const;

